/* PGMaritalStatus.js
   Step 12 — Marital Status (PG-specific, optional).
   Dropdown fetched from CODE_MARITALSTATUS via API.
   Sends MaritalStatusId (int) to backend → Application.MaritalStatus FK.
*/
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import InputRow from './InputRow'

export default class PGMaritalStatus extends Component {
  constructor (props) {
    super(props)
    this.state = {
      maritalStatus: props.maritalStatus || '',
      maritalStatusData: []
    }
  }

  componentDidMount () {
    fetch(`${process.env.REACT_APP_API_URL}/api/PersonalInfo/GetMaritalStatus`)
      .then(res => res.json())
      .then(res => {
        this.setState({ maritalStatusData: res || [] })
      })
      .catch(() => {})

    this.props.collectState('PG_Marital', this.state.maritalStatus)
  }

  render () {
    const { maritalStatus, maritalStatusData } = this.state
    return (
      <div>
        <p style={{ fontSize: 13, color: '#555', marginBottom: 12 }}>
          This section is optional. You may skip it if you prefer not to disclose.
        </p>
        <InputRow
          rowName='Marital Status'
          name='select'
          value={maritalStatus}
          data={maritalStatusData}
          onChange={(val) => {
            this.setState({ maritalStatus: val })
            this.props.collectState('PG_Marital', val)
          }}
        />
        <button className='save' onClick={() => { this.props.onSave() }}>Next</button>
      </div>
    )
  }
}

PGMaritalStatus.propTypes = {
  onSave: PropTypes.func.isRequired,
  collectState: PropTypes.func.isRequired,
  maritalStatus: PropTypes.string
}

PGMaritalStatus.defaultProps = {
  maritalStatus: ''
}
